import paymentHelpers from '@/library/payments/paymentHelpers'
import store from '@/store'

function handleIFrame (params, viewModel) {
  if (params && params.data && params.data.data === 'closeNuveiIFrame') {
    if (viewModel) {
      const isNuveiIFrameOpened = store.getters['nuvei/currentRef']
      viewModel.closeNuveiIFrame()
      if (isNuveiIFrameOpened) {
        store.dispatch('nuvei/nuveiWd/cardCheck')
      }
    }
  }
  if (params && params.data && params.data.messageID === 'navigate2NuveiPaymentCompletedPage') {
    if (viewModel) {
      viewModel.closeNuveiIFrame()
      viewModel.$router.push({
        name: 'nuvei-payment-completed',
        query: paymentHelpers.createObjectFromURLWithQueryParams(params.data.payload && params.data.payload)
      })
    }
  }
  if (params && params.data && params.data.messageID === 'navigate2NuveiPaymentFailedPage') {
    if (viewModel) {
      viewModel.closeNuveiIFrame()
      viewModel.$router.push({
        name: 'nuvei-payment-failed'
      })
    }
  }
}

function handleNuveiOnMount () {
  const cardCheckIsScheduled = store.getters['nuvei/scheduleCardCheck']
  if (cardCheckIsScheduled) {
    store.dispatch('nuvei/nuveiWd/cardCheck')
    store.commit('nuvei/scheduleCardCheck', false)
  }
  store.commit('nuvei/setCurrentNuveiType', null)
}

function checkIsRedirectedFromInAppBrowserAndIntercept () {
  let url = window.location.href
  const IsRedirectedFromNuvei = url.includes('nuvei-redirect-mobile')
  const isWebView = !window.ctsautoconf.MOBILE_LS
  // Nuvei
  if (IsRedirectedFromNuvei && isWebView) {
    url = url.replace(/\/nuvei-redirect-mobile-[A-Za-z]+/, '')
    const origin = window.location.origin
    const formatedOrigin = paymentHelpers.removeTrailingSlash(origin)
    url = url.replaceAll(formatedOrigin, 'igt-nuvei-link:/')
    document.location = url
  }
}

function getReturnUrl (param) {
  const origin = window.ctsautoconf.WEB_SERVER_HOSTNAME || ''
  const capacitorIsEnabled = window.ctsautoconf.CAPACITOR_ENABLED || false
  const isMobileApp = window.ctsautoconf.MOBILE_LS || false
  if (capacitorIsEnabled && isMobileApp) {
    const formatedOrigin = paymentHelpers.removeTrailingSlash(origin)
    return `${formatedOrigin}/nuvei-redirect-mobile-${param}/`
  }
  return `${window.location.origin}`
}

export default {
  handleIFrame,
  handleNuveiOnMount,
  checkIsRedirectedFromInAppBrowserAndIntercept,
  getReturnUrl
}



// WEBPACK FOOTER //
// ./src/library/payments/nuveiManager.js